    (function() {
    "use strict";

    var directive = function factory() {
        return {
            templateUrl: 'app/modules/quote/directives/vehicle-rate-directive.html',
            replace: false,
            transclude: false,
            restrict: 'E',
            require: '^vehicleSingleProduct',
            scope: {prodid: '@', viewMode:'='},
            controller: 'vehicleRateController'
        };
    };

    quoteModule.directive('vehicleRate', directive);

})();